// extracted by mini-css-extract-plugin
module.exports = {"HomeDiv":"Home_HomeDiv__LKyUS","HomeBg":"Home_HomeBg__3c6LG","texto":"Home_texto__3427E","Pbutton":"Home_Pbutton__37Bus","paginado":"Home_paginado__jXb8Z"};